import { render, staticRenderFns } from "./LoadXML.vue?vue&type=template&id=15c9e2c8&scoped=true"
import script from "./LoadXML.vue?vue&type=script&lang=js"
export * from "./LoadXML.vue?vue&type=script&lang=js"
import style0 from "./LoadXML.vue?vue&type=style&index=0&id=15c9e2c8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c9e2c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15c9e2c8')) {
      api.createRecord('15c9e2c8', component.options)
    } else {
      api.reload('15c9e2c8', component.options)
    }
    module.hot.accept("./LoadXML.vue?vue&type=template&id=15c9e2c8&scoped=true", function () {
      api.rerender('15c9e2c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/LoadXML.vue"
export default component.exports